module.exports = __webpack_public_path__ + "img/no_image.29a5956e.png";